<template>
  <main name="organism-create-new-contract">
    <section name="customer-detail" class="mb-2 customer-detail-container">
      <molecule-customer-detail
        :hasEditPermission="hasUpdateNtdcContractPermission"
        :businessTypeOption="businessTypeOption"
        :propContractDetail="currentContractDetail"
        :generatedAccountData="generatedAccountData"
        @onGenerateCustomerAccount="onGenerateCustomerAccount"
      ></molecule-customer-detail>
    </section>

    <section name="contract-additional-id">
      <molecule-contract-additional-id
        v-model="currentStateContractDetail.additionalIds"
        :contractStatus="propContractDetail.status"
        :isEnableAddNew="hasUpdateNtdcContractPermission"
        :isDeletable="hasUpdateNtdcContractPermission"
      ></molecule-contract-additional-id>
    </section>

    <section name="service-detail" class="mb-2 service-detail-container">
      <molecule-service-detail
        v-model="currentContractForWatch"
        :hasEditPermission="hasUpdateNtdcContractPermission"
        :contractStatus="propContractDetail.status"
        :serviceOption="serviceOption"
        :locationOption="locationOption"
        :isValidateTrigger="isValidateTrigger"
        :funcGetPackageNameList="funcGetPackageNameList"
        :funcGetServiceAndPackageDetail="funcGetServiceAndPackageDetail"
        @onUpdateError="onUpdateErrorInMoleculeServiceDetail"
        @onUpdateGeneralServiceInfo="onUpdateGeneralServiceInfo"
        @onUpdateContractPackages="onUpdateContractPackages"
        @onClickGoToIpam="onClickGoToIpam"
        @onSelectSite="onSelectSite"
      ></molecule-service-detail>
    </section>

    <section name="contract-note" class="mb-2 contract-note-container">
      <molecule-view-and-edit-contract-note
        :hasChange="isContractDetailChange"
        :hasEditPermission="hasUpdateNtdcContractPermission"
        :contractNoteList="propContractDetail.contractNotes"
        :contractStatus="currentContractDetail.status"
        :isErrorOccur="isErrorOccur"
        @onRequestAddNewNote="onRequestAddNewNote"
        @onRequestDeleteNote="onRequestDeleteNote"
        @onRequestSaveChangesContract="onRequestSaveChangesContract"
      ></molecule-view-and-edit-contract-note>
    </section>

    <section name="contact-point" class="mb-2 contact-point-container">
      <molecule-contact-point
        :hasEditPermission="hasUpdateNtdcContractPermission"
        :basedContactPointList="propContractDetail.contactPoints"
        :contractStatus="currentContractDetail.status"
        :contactPointOption="contactPointOption"
        :locationOption="locationOption"
        :formOption="formOption"
        :selectedContactPointId="selectedContactPointId"
        :selectedContactPointDetail="selectedContactPointDetail"
        :isValidateTrigger="isValidateTrigger"
        @onClearSelectedContactPointId="onClearSelectedContactPointId"
        @onRequestForm="onRequestForm"
        @onSelectContactPoint="onSelectContactPoint"
        @onUpdateCurrentContactPointList="onUpdateContactPoints"
        @onRequestCreateNewContactPoint="onRequestCreateNewContactPoint"
        @onUpdateContactPointProfilePicture="onUpdateContactPointProfilePicture"
        @onUpdateErrorAtMoleculeContactPoint="
          onUpdateErrorAtMoleculeContactPoint
        "
      ></molecule-contact-point>
    </section>

    <section name="sale-contact" class="mb-2 sale-contact-container">
      <molecule-sale-contact
        :hasEditPermission="hasUpdateNtdcContractPermission"
        :basedSaleContactList="propContractDetail.saleContact"
        :contractStatus="currentContractDetail.status"
        :saleOption="saleOption"
        :selectedSaleContactId="selectedSaleContactId"
        :selectedSaleContactDetail="selectedSaleContactDetail"
        :isValidateTrigger="isValidateTrigger"
        @onClearSelectedSaleContactId="onClearSelectedSaleContactId"
        @onSelectSaleContact="onSelectSaleContact"
        @onUpdateCurrentSaleList="onUpdateSaleContact"
        @onRequestCreateNewSaleContact="onRequestCreateNewSaleContact"
        @onUpdateSaleProfilePicture="onUpdateSaleProfilePicture"
        @onUpdateErrorAtMoleculeSaleContact="onUpdateErrorAtMoleculeSaleContact"
      ></molecule-sale-contact>
    </section>

    <section name="contract-attachment" class="mb-2">
      <molecule-attachment-list
        :hasChange="isContractDetailChange"
        :hasEditPermission="hasUpdateNtdcContractPermission"
        :isErrorOccur="isErrorOccur"
        :attachmentList="currentContractForWatch.contractAttachments"
        :tagList="attachmentTagOption"
        :contractStatus="currentContractDetail.status"
        @onRequestSaveChangesContract="onRequestSaveChangesContract"
        @onRequestAddAttachment="onRequestAddAttachment"
        @onRequestEditAttachment="onRequestEditAttachment"
        @onRequestDeleteAttachment="onRequestDeleteAttachment"
      ></molecule-attachment-list>
    </section>

    <section name="contract-escalation" class="mb-2">
      <b-card>
        <molecule-escalation-selection
          v-model="escalationSelected"
          :is-disable-select="!hasUpdateNtdcContractPermission || !hasReadTicketEscalationPermission"
          :escalation-template-list="escalationTemplateList"
          :escalation-name="escalationDetail.name"
          :description="escalationDetail.description"
          :levels="escalationDetail.levels"
          :is-show-info="true"
        />
      </b-card>
    </section>

    <!-- Start Button Section -->
    <section
      v-if="isShowButtonSection"
      name="button-section"
      class="d-flex justify-content-between"
    >
      <div class="delete-button-container">
        <atom-button
          v-if="hasDeleteNtdcContractPermission"
          buttonId="button-delete-contract"
          buttonColor="danger"
          buttonStyle="border"
          @click="onClickDeleteContract"
        >
          <feather-icon icon="Trash2Icon" class="delete__icon--style" />
          <span>Delete</span>
        </atom-button>
      </div>
      <div class="d-flex action-button-container">
        <atom-button
          v-if="isShowSaveChangeButton && hasUpdateNtdcContractPermission"
          buttonId="confirm-add-customer-button"
          @click="onClickSaveChangeButton"
        >
          <span>Save Change</span>
        </atom-button>

        <atom-button
          v-if="isShowApproveButton && hasApprovalNtdcContractPermission"
          buttonId="approve-contract-button"
          buttonColor="success"
          @click="onClickApproveButton"
        >
          <span>Approve</span>
        </atom-button>

        <atom-button
          v-if="isShowResumeButton && hasApprovalNtdcContractPermission"
          buttonId="resume-contract-button"
          buttonColor="success"
          @click="onClickResumeButton"
        >
          <span>Resume</span>
        </atom-button>

        <atom-button
          v-if="isShowRenewButton && hasApprovalNtdcContractPermission"
          buttonId="renew-contract-button"
          buttonColor="success"
          @click="onClickRenewButton"
        >
          <span>Renew</span>
        </atom-button>

        <atom-button
          v-if="isShowSuspendButton && hasApprovalNtdcContractPermission"
          buttonId="suspend-contract-button"
          buttonColor="warning"
          @click="onClickSuspendButton"
        >
          <span>Suspend</span>
        </atom-button>

        <atom-button
          v-if="isShowExpireButton && hasApprovalNtdcContractPermission"
          class="ml-1"
          buttonId="expired-contract-button"
          buttonStyle="border"
          buttonColor="secondary"
          @click="onClickExpiredButton"
        >
          <span>Expire</span>
        </atom-button>

        <atom-button
          v-if="isShowCancelButton"
          class="ml-1"
          buttonId="cancel-add-customer-button"
          buttonStyle="border"
          buttonColor="secondary"
          @click="onClickCancelButton"
        >
          <span>Cancel</span>
        </atom-button>
      </div>
    </section>
    <!-- End Button Section -->

    <!-- Footer to make margin bottom of card -->
    <footer style="height: 12px"></footer>

    <molecule-modal-dialog
      modalId="modal-confirm-delete-contract"
      :textTitle="`Do you want to delete\n“Contract ID: ${contractId}” ?`"
      :textSubtitle="`You won’t be able to revert this!\nThis Contract will be changed status to deleted`"
      buttonTextLeft="Delete"
      buttonColorLeft="danger"
      buttonTextRight="Cancel"
      :isTextCenter="true"
      :isSlotBody="true"
      :isCloseOnBackDrop="false"
      :isDisableButtonLeft="textConfirmDeleteContract !== 'delete'"
      @clickButtonLeft="onClickDeleteContractFromModal"
      @clickButtonRight="onclickCancelDeleteContractFromModal"
      @clickIconClose="onclickCancelDeleteContractFromModal"
    >
      <template #body>
        <div class="col-12 col-md-8">
          <atom-input
            placeholder="delete"
            title="Please type delete to confirm"
            v-model="textConfirmDeleteContract"
          ></atom-input>
        </div>
      </template>
    </molecule-modal-dialog>

    <molecule-modal-dialog
      modalId="modal-confirm-approve-contract"
      :isTextCenter="true"
      :textTitle="`Do you want to approve\n“Contract ID: ${contractId}” ?`"
      textSubtitle="This Contract will be changed status to approved"
      buttonTextLeft="Confirm"
      buttonTextRight="Cancel"
      @clickButtonLeft="clickConfirmApproveFromModal"
    >
    </molecule-modal-dialog>

    <molecule-modal-dialog
      modalId="modal-confirm-resume-contract"
      :isTextCenter="true"
      :textTitle="`Do you want to resume\n“Contract ID: ${contractId}” ?`"
      textSubtitle="This Contract will be changed status to approved"
      buttonTextLeft="Confirm"
      buttonTextRight="Cancel"
      @clickButtonLeft="clickConfirmResumeFromModal"
    >
    </molecule-modal-dialog>

    <molecule-modal-dialog
      modalId="modal-confirm-renew-contract"
      :isTextCenter="true"
      :textTitle="`Do you want to renew\n“Contract ID: ${contractId}” ?`"
      textSubtitle="This Contract will be changed status to approved"
      buttonTextLeft="Confirm"
      buttonTextRight="Cancel"
      @clickButtonLeft="clickConfirmRenewFromModal"
    >
    </molecule-modal-dialog>

    <molecule-modal-dialog
      modalId="modal-confirm-suspend-contract"
      :isTextCenter="true"
      :textTitle="`Do you want to suspend\n“Contract ID: ${contractId}” ?`"
      textSubtitle="This Contract will be changed status to suspended"
      buttonTextLeft="Confirm"
      buttonTextRight="Cancel"
      @clickButtonLeft="clickConfirmSuspendFromModal"
    >
    </molecule-modal-dialog>

    <molecule-modal-dialog
      modalId="modal-confirm-expire-contract"
      :isTextCenter="true"
      :textTitle="`Do you want to change status\n“Contract ID: ${contractId}” ?`"
      textSubtitle="This Contract will be changed status to expired"
      buttonTextLeft="Confirm"
      buttonTextRight="Cancel"
      @clickButtonLeft="clickConfirmExpireFromModal"
    >
    </molecule-modal-dialog>

    <molecule-modal-dialog
      modalId="modal-confirm-save-change-contract"
      :isTextCenter="true"
      :textTitle="`Do you want to save changes \n“Contract ID: ${contractId}” ?`"
      textSubtitle="This contract detail will be changed"
      buttonTextLeft="Save Changes"
      buttonTextRight="Cancel"
      @clickButtonLeft="onClickConfirmSaveChangeContractDetailFromModal"
    >
    </molecule-modal-dialog>

    <molecule-modal-dialog
      modalId="modal-confirm-discard-change"
      :isTextCenter="true"
      textTitle="Do you want to leave without finishing?"
      buttonTextLeft="Confirm"
      @clickButtonLeft="onClickConfirmDiscardChangeFromModal"
    >
    </molecule-modal-dialog>
  </main>
</template>

<script>
import AtomButton from "@/components/atoms/AtomButton.vue"
import AtomInput from "@/components/atoms/AtomInput.vue"
import MoleculeCustomerDetail from "@/components/molecules/portal/idc/MoleculeCustomerDetail.vue"
import MoleculeServiceDetail from "@/components/molecules/portal/idc/MoleculeServiceDetail.vue"
import MoleculeViewAndEditContractNote from "@/components/molecules/portal/idc/MoleculeViewAndEditContractNote.vue"
import MoleculeContactPoint from "@/components/molecules/portal/idc/MoleculeContactPoint.vue"
import MoleculeSaleContact from "@/components/molecules/portal/idc/MoleculeSaleContact.vue"
import MoleculeModalDialog from "@/components/molecules/MoleculeModalDialog.vue"
import MoleculeAttachmentList from "@/components/molecules/portal/idc/MoleculeAttachmentList.vue"
import mixins from "@/mixins"
import mixinsDatetime from "@/mixins/mixinsDatetime"
import mixinsObjectHelper from "@/mixins/mixinsObjectHelper"
import mixinsValidator from "@/mixins/mixinsValidator"
import MoleculeEscalationSelection from "@/components/molecules/portal/escalationSelection/MoleculeEscalationSelection.vue"
import MoleculeContractAdditionalId from "@/components/molecules/portal/idc/MoleculeContractAdditionalId.vue"
import { BCard } from "bootstrap-vue"
import { PermissionUser } from "@/constants/permission-user"
import mixinsUser from "@/mixins/mixinsUser"

export default {
  name: "OrganismIdcEditAndActionContract",
  components: {
    AtomButton,
    AtomInput,
    MoleculeCustomerDetail,
    MoleculeServiceDetail,
    MoleculeViewAndEditContractNote,
    MoleculeContactPoint,
    MoleculeSaleContact,
    MoleculeModalDialog,
    MoleculeAttachmentList,
    MoleculeEscalationSelection,
    MoleculeContractAdditionalId,
    BCard,
  },
  mixins: [
    mixins,
    mixinsDatetime,
    mixinsValidator,
    mixinsObjectHelper,
    mixinsUser,
  ],
  props: {
    businessTypeOption: {
      type: Array,
      required: false,
      default: () => [],
    },
    serviceOption: {
      type: Array,
      required: true,
    },
    locationOption: {
      type: Array,
      required: true,
    },
    contactPointOption: {
      type: Array,
      required: true,
    },
    saleOption: {
      type: Array,
      required: true,
    },
    formOption: {
      type: Array,
      required: true,
    },
    contactPointDetail: {
      type: Object,
      required: false,
      default: null,
    },
    saleDetail: {
      type: Object,
      required: false,
      default: null,
    },
    selectedContactPointId: {
      type: String,
      required: false,
      default: null,
    },
    selectedContactPointDetail: {
      type: Object,
      required: false,
      default: null,
    },
    selectedSaleContactId: {
      type: String,
      required: false,
      default: null,
    },
    selectedSaleContactDetail: {
      type: Object,
      required: false,
      default: null,
    },
    generatedAccountData: {
      type: Object,
      required: false,
      default: null,
    },
    serviceDetailInfo: {
      type: Array,
      required: false,
      default: () => [],
    },
    attachmentTagOption: {
      type: Array,
      required: false,
      default: () => [],
    },
    funcGetPackageNameList: {
      type: Function,
      required: true,
      default: () => {},
    },
    funcGetServiceAndPackageDetail: {
      type: Function,
      required: true,
      default: () => {},
    },
    value: {
      type: Object,
      required: true,
    },
    escalationTemplateList: {
      type: Array,
      required: true,
    },
    escalation: {
      type: Object,
      required: false,
      default: () => {},
    },
    currentEscalationId: {
      type: [String, null],
      required: false,
      default: null,
    },
    escalationDetail: {
      type: Object,
      required: false,
      default: () => {},
    },
  },
  emits: ["onChangeEscalationTemplate"],
  data() {
    return {
      currentContractDetail: {},
      originStateContractDetail: {},
      currentStateContractDetail: {},
      isContractDetailChange: false,
      isValidateTrigger: false,
      isErrorOccurInMoleculeService: false,
      isErrorOccurAtAdditionalPackageInMoleculeService: false,
      isErrorOccurAtSelectContactPoint: false,
      isErrorOccurAtSelectSaleContact: false,
      textConfirmDeleteContract: "",
    }
  },
  computed: {
    propContractDetail: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit("input", value)
      },
    },

    currentContractForWatch() {
      return this.deepCopyObject(this.currentContractDetail)
    },

    hasApprovalNtdcContractPermission() {
      return this.hasPermission(PermissionUser.WPM.NTDC_CONTRACT_APPROVAL_WRITE)
    },
    hasUpdateNtdcContractPermission() {
      return this.hasPermission(PermissionUser.WPM.NTDC_CONTRACT_WRITE)
    },
    hasDeleteNtdcContractPermission() {
      return this.hasPermission(PermissionUser.WPM.NTDC_CONTRACT_DELETE)
    },
    hasReadTicketEscalationPermission() {
      return this.hasPermission(PermissionUser.WPM.TICKET_ESCALATION_READ)
    },

    contractId() {
      return this.$route?.params?.id
    },

    isShowButtonSection() {
      return this.propContractDetail?.status?.toLowerCase() !== "deleted"
    },

    isShowSaveChangeButton() {
      return this.isContractDetailChange
    },

    isShowApproveButton() {
      return (
        this.propContractDetail?.status?.toLowerCase() === "pending" &&
        !this.isShowSaveChangeButton
      )
    },

    isShowResumeButton() {
      return (
        this.propContractDetail?.status?.toLowerCase() === "suspended" &&
        !this.isShowSaveChangeButton
      )
    },

    isShowRenewButton() {
      return (
        this.propContractDetail?.status?.toLowerCase() === "expired" &&
        !this.isShowSaveChangeButton
      )
    },

    isShowSuspendButton() {
      return (
        this.propContractDetail?.status?.toLowerCase() === "approved" &&
        !this.isShowSaveChangeButton
      )
    },

    isShowExpireButton() {
      return (
        this.propContractDetail?.status?.toLowerCase() === "approved" &&
        !this.isShowSaveChangeButton
      )
    },

    isShowCancelButton() {
      return (
        this.propContractDetail?.status?.toLowerCase() !== "approved" || false
      )
    },

    isErrorOccur() {
      return (
        this.isErrorOccurInMoleculeService ||
        this.isErrorOccurAtSelectContactPoint ||
        this.isErrorOccurAtSelectSaleContact
      )
    },

    escalationSelected: {
      get() {
        return this.escalation
      },
      set(newValue) {
        this.$emit("onChangeEscalationTemplate", newValue)
      },
    },
  },
  watch: {
    propContractDetail: {
      deep: true,
      handler() {
        if (this.propContractDetail) {
          this.isValidateTrigger = false
          const decoratedData = this.decoratePropContractDetail(
            this.propContractDetail
          )
          this.originStateContractDetail = this.deepCopyObject(decoratedData)
          this.currentStateContractDetail = this.deepCopyObject(decoratedData)
          // currentContractDetail store all current properties that not use for compare change
          this.currentContractDetail = this.deepCopyObject(decoratedData)
          // in case emit from has change modal to update data
          this.checkContractDetailChange()
        }
      },
    },

    escalationSelected: {
      deep: true,
      handler() {
        this.checkContractDetailChange()
      },
    },

    "currentStateContractDetail.additionalIds": {
      deep: true,
      handler() {
        this.currentContractDetail.additionalIds = this.deepCopyObject(
          this.currentStateContractDetail.additionalIds
        )
        this.checkContractDetailChange()
      },
    },
  },
  methods: {
    decoratePropContractDetail(contractDetail) {
      const rawContractData = this.deepCopyObject(contractDetail)

      return {
        contractId: rawContractData.contractId,
        additionalIds: rawContractData.additionalIds,
        status: rawContractData.status,
        customer: rawContractData.customer,
        isUserGenerated: rawContractData.isUserGenerated,
        generalServiceInfo: {
          siteId: rawContractData.siteId,
          contractStartDate: this.setTimeZone(rawContractData.startDate),
          ipAddresses: rawContractData.ipAddresses.map((item) => item.ip),
          otherTechnicalDetail: rawContractData.otherTechnicalDetail,
        },
        packages: rawContractData.packages.map((item) => {
          const {
            serviceInformation,
            departmentId,
            locationName,
            packageName,
            packagePeriodName,
            serviceName,
            oceanRacks,
            ...packageData
          } = item
          return {
            ...packageData,
            rack: oceanRacks,
            startDate: this.setTimeZone(item.startDate),
            packageQuantity: this.getNumberOrNull(item.packageQuantity),
            packageOptions: this.decoratePackageOptions(item.packageOptions),
          }
        }),
        contractNotes: rawContractData.contractNotes,
        contactPoints: rawContractData.contactPoints,
        saleContact: [rawContractData.saleContact],
        contractAttachments: rawContractData.contractAttachments,
      }
    },

    onUpdateGeneralServiceInfo(updateData) {
      const decoratedUpdateData = {
        siteId: updateData?.site?.siteId,
        contractStartDate: this.setTimeZone(updateData?.contractStartDate),
        ipAddresses: updateData?.ipAddresses,
        otherTechnicalDetail: this.getStringOrNull(
          updateData?.otherTechnicalDetail
        ),
      }

      this.currentStateContractDetail.generalServiceInfo = decoratedUpdateData
      this.currentContractDetail.generalServiceInfo = decoratedUpdateData
      this.checkContractDetailChange()
    },

    onUpdateContractPackages(updateData) {
      const decoratedUpdateData = updateData.map((item) => {
        return {
          serviceId: item.service?.serviceId,
          packageId: item.package?.packageId,
          packageQuantity: this.getNumberOrNull(item.packageQuantity),
          packagePeriodId: item.packagePeriod?.packagePeriodId,
          locationId: item.location?.locationId,
          packageOptions: this.decoratePackageOptions(item.packageOptions),
          bundleNetwork: item.bundleNetwork,
          contractPackageId: item?.contractPackageId,
          rack: item.rack,
          domain: item.domain,
          startDate: this.setTimeZone(item.startDate),
          serviceNote: this.getStringOrNull(item.serviceNote),
          endDate: this.getStringOrNull(item.endDate),
        }
      })
      this.currentStateContractDetail.packages = decoratedUpdateData
      this.currentContractDetail.packages = decoratedUpdateData
      this.checkContractDetailChange()
    },

    decoratePackageOptions(packageOptions) {
      return packageOptions
        ? packageOptions.map((item) => {
            return {
              optionId: item.optionId,
              optionName: item.optionName,
              price: item.price,
              quantity: item.quantity,
            }
          })
        : []
    },

    onUpdateContactPoints(updateData) {
      const decoratedUpdateData = updateData.map((contact) => {
        return {
          contactPointId: contact.name.contactPointId,
          contactPointEmailId: contact.email.contactPointEmailId,
          contactPointPhoneId: contact.phone.contactPointPhoneId,
        }
      })
      this.currentStateContractDetail.contactPoints = decoratedUpdateData
      this.currentContractDetail.contactPoints = decoratedUpdateData
      this.checkContractDetailChange()
    },

    onUpdateSaleContact(updateData) {
      const decoratedUpdateData = updateData.map((contact) => {
        return {
          contactPointId: contact.name.contactPointId,
          contactPointEmailId: contact.email.contactPointEmailId,
          contactPointPhoneId: contact.phone.contactPointPhoneId,
        }
      })
      this.currentStateContractDetail.saleContact = decoratedUpdateData
      this.currentContractDetail.saleContact = decoratedUpdateData
      this.checkContractDetailChange()
    },

    checkContractDetailChange() {
      const isAdditionalIdsChange = this.compareIsChangeObject(
        this.originStateContractDetail.additionalIds,
        this.currentStateContractDetail.additionalIds
      )

      const isGeneralServiceInfoChange = this.compareIsChangeObject(
        this.originStateContractDetail.generalServiceInfo,
        this.currentStateContractDetail.generalServiceInfo
      )

      const isPackagesChange = this.compareIsChangeArray(
        this.originStateContractDetail.packages,
        this.currentStateContractDetail.packages
      )

      const isContactPointsChange = this.compareIsChangeArray(
        this.originStateContractDetail.contactPoints,
        this.currentStateContractDetail.contactPoints
      )

      const isSaleContactChange = this.compareIsChangeArray(
        this.originStateContractDetail.saleContact,
        this.currentStateContractDetail.saleContact
      )

      const isEscalationChange = Boolean(
        (!this.currentEscalationId && this.escalationSelected?.escalationId) ||
          (this.currentEscalationId &&
            this.currentEscalationId !== this.escalationSelected?.escalationId)
      )

      this.isContractDetailChange =
        isAdditionalIdsChange ||
        isGeneralServiceInfoChange ||
        isPackagesChange ||
        isContactPointsChange ||
        isSaleContactChange ||
        isEscalationChange
    },

    // Event from buttons and modals
    onClickSaveChangeButton() {
      this.isValidateTrigger = true
      this.$nextTick(() => {
        if (!this.isErrorOccur) {
          this.modalId = "modal-confirm-save-change-contract"
          this.$bvModal.show(this.modalId)
        } else {
          this.toastWarning("Please Check Your Data")
        }
      })
    },
    onClickConfirmSaveChangeContractDetailFromModal() {
      this.$emit("onSaveChangeContractDetail", this.currentContractDetail)
      this.closeModal()
    },
    onClickApproveButton() {
      this.modalId = "modal-confirm-approve-contract"
      this.$bvModal.show(this.modalId)
    },
    clickConfirmApproveFromModal() {
      const contractId = this.contractId.replace(/\D/g, "")
      this.$emit("onConfirmApproveContract", contractId)
      this.closeModal()
    },
    onClickDeleteContract() {
      this.modalId = "modal-confirm-delete-contract"
      this.$bvModal.show(this.modalId)
    },
    onClickDeleteContractFromModal() {
      const contractId = this.contractId.replace(/\D/g, "")
      this.$emit("onConfirmDeleteContract", contractId)
      this.closeModal()
      this.textConfirmDeleteContract = ""
    },
    onclickCancelDeleteContractFromModal() {
      this.closeModal()
      this.textConfirmDeleteContract = ""
    },
    onClickResumeButton() {
      this.modalId = "modal-confirm-resume-contract"
      this.$bvModal.show(this.modalId)
    },
    clickConfirmResumeFromModal() {
      const contractId = this.contractId.replace(/\D/g, "")
      this.$emit("onConfirmResumeContract", contractId)
      this.closeModal()
    },
    onClickRenewButton() {
      this.modalId = "modal-confirm-renew-contract"
      this.$bvModal.show(this.modalId)
    },
    clickConfirmRenewFromModal() {
      const contractId = this.contractId.replace(/\D/g, "")
      this.$emit("onConfirmRenewContract", contractId)
      this.closeModal()
    },
    onClickSuspendButton() {
      this.modalId = "modal-confirm-suspend-contract"
      this.$bvModal.show(this.modalId)
    },
    clickConfirmSuspendFromModal() {
      const contractId = this.contractId.replace(/\D/g, "")
      this.$emit("onConfirmSuspendContract", contractId)
      this.closeModal()
    },
    onClickExpiredButton() {
      this.modalId = "modal-confirm-expire-contract"
      this.$bvModal.show(this.modalId)
    },
    clickConfirmExpireFromModal() {
      const contractId = this.contractId.replace(/\D/g, "")
      this.$emit("onConfirmExpireContract", contractId)
      this.closeModal()
    },
    onClickCancelButton() {
      if (this.isShowSaveChangeButton) {
        this.modalId = "modal-confirm-discard-change"
        this.$bvModal.show(this.modalId)
      } else {
        this.navigateTo("/internal/web-portal/idc")
      }
    },
    onClickConfirmDiscardChangeFromModal() {
      this.$bvModal.hide(this.modalId)
      this.$router.go()
    },
    onClickGoToIpam() {
      this.openNewTabs("/internal/web-portal/ipam")
    },

    // Emit event to parent components
    onSelectSite(selectedSite, updatedContractPackages) {
      this.onUpdateContractPackages(updatedContractPackages)
      this.$emit("onSelectSite", selectedSite)
    },
    onSelectService(selectedService) {
      this.$emit("onSelectService", selectedService)
    },
    onAddNewCustomer(newCustomerData) {
      this.$emit("onAddNewCustomer", newCustomerData)
    },
    onSelectPackage(selectedPackage, selectedService) {
      this.$emit("onSelectPackage", selectedPackage, selectedService)
    },
    onSelectContactPoint(selectedContactPoint) {
      this.$emit("onSelectContactPoint", selectedContactPoint)
    },
    onClearSelectedContactPointId() {
      this.$emit("onClearSelectedContactPointId")
    },
    onSelectSaleContact(selectedSaleContact) {
      this.$emit("onSelectSaleContact", selectedSaleContact)
    },
    onClearSelectedSaleContactId() {
      this.$emit("onClearSelectedSaleContactId")
    },
    onRequestCreateNewContactPoint(newContactPointDetail) {
      this.$emit("onRequestCreateNewContactPoint", newContactPointDetail)
    },
    onUpdateContactPointProfilePicture(newProfilePicture) {
      this.$emit("onUpdateContactPointProfilePicture", newProfilePicture)
    },
    onRequestCreateNewSaleContact(newSaleContactDetail) {
      this.$emit("onRequestCreateNewSaleContact", newSaleContactDetail)
    },
    onUpdateSaleProfilePicture(newProfilePicture) {
      this.$emit("onUpdateSaleProfilePicture", newProfilePicture)
    },
    onRequestCreateNewSaleContact(newSaleContactDetail) {
      this.$emit("onRequestCreateNewSaleContact", newSaleContactDetail)
    },
    onRequestForm(contractId, formId, requestFormData) {
      this.$emit("onRequestForm", contractId, formId, requestFormData)
    },
    onGenerateCustomerAccount(generateAccountData) {
      this.$emit("onGenerateCustomerAccount", generateAccountData)
    },
    onRequestAddNewNote(contractId, newNoteData) {
      this.$emit("onRequestAddNewNote", contractId, newNoteData)
    },
    onRequestDeleteNote(contractId, targetNoteId) {
      this.$emit("onRequestDeleteNote", contractId, targetNoteId)
    },
    onRequestAddAttachment(attachment) {
      this.$emit("onRequestAddAttachment", attachment)
    },
    onRequestEditAttachment(attachment) {
      this.$emit("onRequestEditAttachment", attachment)
    },
    onRequestDeleteAttachment(attachment) {
      this.$emit("onRequestDeleteAttachment", attachment)
    },
    onRequestSaveChangesContract() {
      this.isValidateTrigger = true
      this.$nextTick(() => {
        if (!this.isErrorOccur) {
          this.$emit("onSaveChangeContractDetail", this.currentContractDetail)
          this.checkContractDetailChange()
        } else {
          this.closeModal()
          this.toastWarning("Please Check Your Data")
        }
      })
    },

    // Emit update error from child components
    onUpdateErrorInMoleculeServiceDetail(isError) {
      this.isErrorOccurInMoleculeService = isError
    },
    onUpdateErrorAtMoleculeContactPoint(isError) {
      this.isErrorOccurAtSelectContactPoint = isError
    },
    onUpdateErrorAtMoleculeSaleContact(isError) {
      this.isErrorOccurAtSelectSaleContact = isError
    },

    // Utilities methods
    closeModal() {
      this.$bvModal.hide(this.modalId)
      this.modalId = ""
    },
    getNumberOrNull(number) {
      return number ? Number(number) : null
    },
    getStringOrNull(text) {
      return this.hasString(text) ? text : null
    },
    navigateTo(path) {
      this.$router.push(path)
    },
    openNewTabs(destination) {
      const route = this.$router.resolve({
        path: destination,
      })
      window.open(route.href)
    },
  },
}
</script>

<style lang="scss" scoped>
.customer-detail-container,
.service-detail-container,
.contract-note-container,
.contact-point-container,
.sale-contact-container {
  width: 100%;
  height: 100%;
  background: white;
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);
  border-radius: 6px;
}

.delete__icon--style {
  margin-right: 5px;
}
</style>
